import { useId } from 'react';

import { ManifestSecretProps } from '../../Manifest.utils';

function GoogleAuthCredentialsInput(props: {
  value: string;
  onChange: (value: string) => void;
}) {
  const id = useId();

  let identity: { client_email: string; private_key_id: string } | null = null;
  try {
    const json = JSON.parse(props.value) as unknown;
    if (
      typeof json === 'object' &&
      json !== null &&
      'client_email' in json &&
      typeof json['client_email'] === 'string' &&
      'private_key_id' in json &&
      typeof json['private_key_id'] === 'string'
    ) {
      identity = {
        client_email: json['client_email'],
        private_key_id: json['private_key_id'],
      };
    }
  } catch {
    // ignore
  }

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="font-mono">
        Service Account Private Key
      </label>
      <div className="relative flex w-full flex-col items-stretch justify-center rounded-md border border-dashed border-secondary bg-secondary-hover outline-brand-green-400 focus-within:outline">
        <input
          type="file"
          id={id}
          accept="application/json"
          className="absolute inset-0 opacity-0"
          onChange={async (e) => {
            const file = await e.target.files?.[0].text();
            props.onChange(file ?? '');
          }}
        />

        {identity && (
          <div className="m-2 flex min-w-0 flex-col gap-2 overflow-hidden rounded-sm bg-background p-4 shadow-sm">
            <div className="min-w-0 overflow-hidden text-ellipsis text-sm">
              <strong>Client Email</strong>:
              <div className="overflow-hidden text-ellipsis font-mono">
                {identity.client_email}
              </div>
            </div>
            <div className="min-w-0 overflow-hidden text-ellipsis text-sm">
              <strong>Private Key ID</strong>:
              <div className="overflow-hidden text-ellipsis font-mono">
                {identity.private_key_id}
              </div>
            </div>
          </div>
        )}

        <span className="flex w-full items-center justify-center text-center text-sm text-tertiary">
          <span className="py-7">Upload or drag-and-drop JSON private key</span>
        </span>
      </div>

      <p className="text-sm text-tertiary">
        Obtain your private key in{' '}
        <a
          href="https://console.cloud.google.com"
          target="_blank"
          rel="noreferer noopener"
          className="text-brand-green-400 hover:underline active:underline"
        >
          Google Cloud Console
        </a>
        .
      </p>
    </div>
  );
}

export function ManifestCommonGoogleVertexAISecret(props: ManifestSecretProps) {
  return (
    <div className="flex flex-col gap-4">
      <GoogleAuthCredentialsInput
        value={props.value['GOOGLE_VERTEX_AI_WEB_CREDENTIALS'] ?? ''}
        onChange={(value) =>
          props.onChange({
            ...props.value,
            ['GOOGLE_VERTEX_AI_WEB_CREDENTIALS']: value,
          })
        }
      />
    </div>
  );
}
